<template>

    <div>

        <h1 class="mt-4">Prislista</h1>

        <div class="content-container">

            <h3>Ladda upp ny prislista</h3>
            <div class="row mb-8">
                <div class="col-5">
                    <input class="form-control form-control-sm" type="file" id="formFile" @change="upload">
                </div>
                <div class="col-5">
                    <div style="padding-top:2px;" v-if="loading"><img src="/images/card/spinner.gif" style="height: 32px; margin-right: 8px;"> Importerar prislista...</div>
                </div>
            </div>

            <div class="alert alert-success mb-8" v-if="success">
                Prislistan har importerats.
            </div>

            <h3 class="mb-4">Aktuell prislista</h3>

            <div class="row gx-1 py-2" style="font-weight: 600; font-size: 14px; background-color: #c6e6db;">
                <div class="col"><div class="ps-3">Min anställda</div></div>
                <div class="col">Max anställda</div>
                <div class="col">Pris</div>
            </div>

            <div class="row gx-1 py-2 pricelist-hover" :key="'prow_'+price.id" v-for="price in currentPrices">
                <div class="col"><div class="ps-3">{{ price.num_employees_min }}</div></div>
                <div class="col">{{ price.num_employees_max }}</div>
                <div class="col">{{ price.price }} kr</div>
            </div>

        </div>

    </div>

</template>

<script>
import axios from 'axios'

export default {

    props: {
        prices: {
            required: true
        }
    },

    data () {
        return {
            currentPrices: this.prices,
            success: false,
            loading: false
        }
    },

    methods: {

        upload (event) {
            this.loading = true

            const files = event.target.files || event.dataTransfer.files
            if (!files.length) { return }

            const formData = new FormData()
            formData.append('excel', files[0], files[0].name)

            this.success = false

            axios.post(
                '/quotationsNewPrices/upload',
                formData
            )
                .then(response => {
                    console.log('upload')
                    console.log(response.data)

                    this.currentPrices = response.data.prices
                    this.success = true
                    this.loading = false

                    setTimeout(() => {
                        this.success = false
                    }, 8000)
                })
                .catch(error => {
                    alert('Uppladdningen misslyckades, vänligen försök igen.')
                })
                .finally(function () {
                    document.getElementById('formFile').value = null
                })
        }

    }
}
</script>
